module.exports = "/_next/static/images/1f28ff42074088da2225e1faaee1d5bc-nubank-indoor-pool@lg-2x.jpg";